import { useEffect } from 'react';

type FiestaIframeMessage = {
  data: string;
};

/**
 * Custom hook to handle "message" events from `window`.
 * @param {object} actionMappings - An object where keys are action names and values are corresponding handlers.
 */
const useIframeMessageHandler = (actionMappings: { [key in string]: (input: any) => void }) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!event.data || typeof event.data !== 'string') {
        return;
      }
      try {
        const message = JSON.parse(event.data);
        if (message.type === 'web-builder-message' && message.action && actionMappings[message.action]) {
          actionMappings[message.action](message?.additionalData);
        }
      } catch (error) {
        // Could be no web-builder-message, or could be a different message type
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [actionMappings]);
};

export default useIframeMessageHandler;
